<!--
 * @message: 
 * @Author: Betway<848032671@qq.com>
 * @Github: github
 * @Date: 2020-07-24 10:24:27
 * @FilePath: \mrc-ess-fronted\src\Page\EssAdmin\Attendance\InternalUse\LeaveApplication\leaveApplication.vue
 * @最后编辑: Betway
 * @最后修改时间: 2022-03-09 13:22:27
-->
<template>
  <ContentLayout
    :title="$t('label_essweb_admin_leaveApplication_list_title')"
    addBtn
    @new="toNew"
    pad="0"
  >
    <template v-slot:page-main>
      <Tabler
        :headers="headers"
        :items="desserts"
        :showSelect="showSelect"
        :height="$vuetify.breakpoint.height - 275"
        :totalCount="totalCount"
        @change="
          (page, perpage, callback) => {
            getList(page, perpage, callback);
          }
        "
      >
        <template v-slot:item.applicant="{ item }">
          <div style="max-width: 300px">
            <v-list-item dense two-line class="pa-0">
              <v-list-item-avatar size="36" class="mr-1 my-0">
                <StaffAvatar
                  size="36"
                  :src="item.agent_staff.staff_avatar"
                  :staff_name="item.agent_staff.preferred_name"
                />
              </v-list-item-avatar>
              <v-list-item-content>
                <v-list-item-title class="table-title text--primary">
                  {{ $getCommonLangValue(item.agent_staff.preferred_name) }}
                  <span class="text--secondary text-caption-xs">
                    {{ item.agent_staff.staff_code }}</span
                  >
                </v-list-item-title>
                <v-list-item-subtitle class="table-subtitle text--secondary">
                  {{ $getCommonLangValue(item.agent_staff.job_post_name) }}
                </v-list-item-subtitle>
              </v-list-item-content>
            </v-list-item>
          </div>
        </template>
        <template v-slot:item.type="{ item }">
          <div class="table-title text--primary">
            {{ $getCommonLangValue(item.leave_type_name) }}
            <span v-if="Number(item.cancel_flag) == 1"
              >({{
                $t("label_essweb_LeaveApplication_list_tag_cancelLabel")
              }})</span
            >
          </div>
        </template>
        <template v-slot:item.startDate="{ item }">
          <div class="table-title text--primary">
            {{ $getDateTime(item.start_utc_datetime, "YYYY/MM/DD") }}
          </div>
          <div class="table-subtitle text--secondary">
            {{ $getDateTime(item.start_utc_datetime, "HH:mm") }}
          </div>
        </template>
        <template v-slot:item.endDate="{ item }">
          <div class="table-title text--primary">
            {{ $getDateTime(item.end_utc_datetime, "YYYY/MM/DD") }}
          </div>
          <div class="table-subtitle text--secondary">
            {{ $getDateTime(item.end_utc_datetime, "HH:mm") }}
          </div>
        </template>
        <template v-slot:item.unit="{ item }">
          <div class="table-title text--primary">
            {{ $getCommonLangValue(item.unit) }}
          </div>
        </template>
        <template v-slot:item.total="{ item }">
          <div class="table-title text--primary">
            {{ parseFloat(Number(item.total_time)) }}
          </div>
        </template>
        <template v-slot:item.applicationDate="{ item }">
          <div class="table-title text--primary">
            {{ $getDateTime(item.submission_utc_datetime, "YYYY/MM/DD") }}
          </div>
        </template>
        <template v-slot:item.status="{ item }">
          <StatusChip
            :slideColor="item.approval_tint_color"
            :bgColor="item.approval_bg_color"
          >
            <template v-slot:status>
              {{ $getCommonLangValue(item.status_detail) }}
            </template>
          </StatusChip>
        </template>
        <template v-slot:item.action="{ item }">
          <v-btn icon @click="toView(item.uuid)">
            <svg-icon size="24" fill="currentColor" iconClass="viewDetail" />
          </v-btn>
        </template>
      </Tabler>
    </template>
    <template v-slot:tools-main>
      <toApply
        :staff_uuid="page_params ? page_params.staff_uuid : null"
        :show="showApply"
        @close="showApply = false"
        @toApply="toApply"
      />
    </template>
  </ContentLayout>
</template>
<script>
import toApply from "@/Page/EssAdmin/Attendance/InternalUse/components/toApply";
export default {
  name: "LeaveApplication",
  components: {
    toApply,
  },
  computed: {},
  data() {
    return {
      showDelete: false,
      totalCount: 0,
      showApply: false,
      showSelect: false,
      headers: [
        {
          text: "label_essweb_leaveApplication_list_applicantLabel",
          value: "applicant",
          align: "start",
          sortable: false,
          filter: (value, search, item) => {
            if (!this.search) return true;
            return (
              item.preferred_name
                .toString()
                .toLocaleUpperCase()
                .indexOf(this.search.toLocaleUpperCase()) != -1
            );
          },
        },
        {
          text: "label_essweb_leaveApplication_list_leaveType",
          value: "type",
          align: "start",
          sortable: false,
        },
        {
          text: "label_essweb_leaveApplication_list_startDateLabel",
          value: "startDate",
          align: "start",
          sortable: false,
        },
        {
          text: "label_essweb_leaveApplication_list_endDateLabel",
          value: "endDate",
          align: "start",
          sortable: false,
        },

        {
          text: "label_essweb_leaveApplication_list_totalLabel",
          value: "total",
          align: "start",
          sortable: false,
        },
        {
          text: "label_essweb_leaveApplication_list_unitLabel",
          value: "unit",
          align: "start",
          sortable: false,
        },
        {
          text: "label_essweb_leaveApplication_list_applicantDateLabel",
          value: "applicationDate",
          align: "start",
          sortable: false,
        },
        {
          text: "label_essweb_leaveApplication_list_statusLabel",
          value: "status",
          align: "start",
          sortable: false,
        },

        {
          text: "label_essweb_list_components_tools_actionLabel",
          value: "action",
          align: "end",
          sortable: false,
        },
      ],
      desserts: [],
      page_params: null,
    };
  },
  mounted() {
    this.page_params = JSON.parse(this.$aesDecrypt(this.$route.params.args));
    this.getList(1, this.$tableSetting.perPageSize, null);
  },
  methods: {
    toNew: function () {
      this.showApply = true;
    },
    toApply(id) {
      this.$toPage(
        "/admin/attendance-internal/attendance-internal-leave-application/add/" +
          this.$aesEncrypt(
            JSON.stringify({
              leave_type_uuid: id,
              staff_uuid: this.page_params.staff_uuid,
            })
          )
      );
    },
    toView: function (uuid) {
      this.$toPage(
        "/admin/attendance-internal/attendance-internal-leave-application/detail/" +
          uuid
      );
    },
    getList: function (page, perpage, callback) {
      const that = this;
      this.$Request({
        method: "POST",
        table: "ess_lv_leave_application_record",
        url: "/leave-application/get-list/",
        data: {
          staff_uuid: this.page_params.staff_uuid,
          cpage: page,
          pagesize: perpage,
        },
      }).then((res) => {
        that.desserts = res.data;
        that.totalCount = res.totalcount;
        callback ? callback() : null;
      });
    },
    toDelete: function (uuid) {},
    toEdit: function (uuid) {},
  },
};
</script>
